export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';
export const PERMISSION_CREATE_MESSAGE = 'User has been created';
export const PERMISSION_EDIT_MESSAGE = 'User has been edited';
export const PERMISSION_DELETE_MESSAGE = 'User has been deleted';
export const SEARCH_DEBOUNCE_DELAY = 1000;
export const PAGE_NUMBER_DEFAULT = 1;
export const PAGE_SIZE_DEFAULT = 10;

export const apiDefault = { isFailed: false, isLoading: false, isSuccess: false, message: '' };
export const apiLoading = { isFailed: false, isLoading: true, isSuccess: false, message: '' };
export const apiSuccess = { isFailed: false, isLoading: false, isSuccess: true, message: '' };
export const apiFail = {
    isFailed: true,
    isLoading: false,
    isSuccess: false,
    message: DEFAULT_ERROR_MESSAGE
};

export enum MESSAGE_UNIT_TYPE {
    Default = -1,
    Error,
    Success
}

export enum COPY_STATUS {
    Default = -1,
    Error,
    Success
}

export enum Action {
    Default,
    Create,
    Edit,
    Archive,
    ViewCode,
    Delete
}

export const PAGINATION_SIZES = [5, 10, 20, 50];
